const addAnswerToComment = (comment, comments) => {
  if (comment.parentId === null || comment.parentId === undefined) {
    return { updated: true, comments: [...(comments || []), comment] }
  }
  if (comments && comments.length > 0) {
    let updated = false
    const newComments = comments.map(item => {
      if (!updated) {
        if (item.id === comment.parentId) {
          const newItem = { ...item }
          newItem.answers = [...(item.answers || []), comment]

          updated = true
          return newItem
        }
        const x = addAnswerToComment(comment, item.answers)
        if (!x.updated) { return item }
        updated = true
        return { ...item, answers: x.comments }
      }
      return item
    })

    return { updated, comments: newComments }
  }
  return { updated: false, comments: [] }
}

export {
  addAnswerToComment
}



// WEBPACK FOOTER //
// ./src/store/utils/commentsUtils.js